// extracted by mini-css-extract-plugin
export default {"input":"input_input__s9grj","error-input":"input_error-input__qtiX7"};